import React from 'react';
import { makeStyles } from '@material-ui/core';
import { TimePicker } from '@material-ui/pickers';
import { classNames, initValue } from '../../utils';

const useStyles = makeStyles((theme) => ({
  timePicker: {
    height: '3.5rem',
    alignItems: 'end',
    justifyContent: 'center',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    paddingLeft: '1.25rem',
    cursor: 'pointer',
    '& .Mui-focused': {
      border: '0 !important',
    },
    '& .MuiInputBase-input': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '0.875rem',
      color: '#2e4469',
      cursor: 'pointer',
      padding: '0',
    },
    '& .MuiInput-underline:before': {
      border: '0 !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      border: '0 !important',
    },
  },
}));

export default function TimePickerBooking(props) {
  const { className, value } = props;
  const classes = useStyles();
  return (
    <TimePicker
      {...props}
      className={className ? `${classNames(classes.timePicker, className)}` : classes.timePicker}
      ampm={false}
      variant="inline"
      value={initValue(value, new Date())}
    />
  );
}
